/**
 * Utility functions for date formatting
 */

/**
 * Safely format a date string to locale date string
 * @param {string|Date|null|undefined} dateString - The date to format
 * @param {Object} options - Options for toLocaleDateString
 * @returns {string} Formatted date or fallback text
 */
export const formatDate = (dateString, options = {}) => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Invalid Date';

  return date.toLocaleDateString(undefined, options);
};

/**
 * Safely format a date string to locale string (includes time)
 * @param {string|Date|null|undefined} dateString - The date to format
 * @param {Object} options - Options for toLocaleString
 * @returns {string} Formatted date and time or fallback text
 */
export const formatDateTime = (dateString, options = {}) => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Invalid Date';

  return date.toLocaleString(undefined, options);
};

/**
 * Format a date for display in dropdowns or lists
 * @param {string|Date|null|undefined} dateString - The date to format
 * @returns {string} Formatted date for display
 */
export const formatDateForDisplay = dateString => {
  if (!dateString) return 'Unknown date';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Invalid Date';

  return date.toLocaleDateString();
};
